/* Woodrow Luxury Wigs — theme.js (no dependencies) */
(function () {
  'use strict';
  var W = window.WLW || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function money(cents) {
    var fmt = W.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = withCommas;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return noDec.replace(/,/g, '.');
      return parts[1] === '00' ? withCommas : withCommas + '.' + parts[1];
    });
  }
  W.money = money;

  /* ---------- Header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  var menu = $('#MobileMenu');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); menu.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }); });

  /* ---------- Announcement rotator ---------- */
  var ann = $$('.announcement__item');
  if (ann.length > 1) {
    var ai = 0;
    setInterval(function () { ann[ai].classList.remove('is-active'); ai = (ai + 1) % ann.length; ann[ai].classList.add('is-active'); }, 4500);
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) { window.location = W.routes.cart; return; } drawer.classList.add('is-open'); drawer.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden'; var c = $('.drawer__head button', drawer); c && c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); refreshCart().then(openDrawer); } }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closePopup(); menu && menu.classList.remove('is-open'); } });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count || ''; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return cart;
    var body = $('.drawer__body', drawer), foot = $('.drawer__foot', drawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p class="serif" style="font-size:28px">Your bag is empty.</p><p class="muted">Begin with a consultation or design your unit now.</p><a class="btn" href="' + esc(drawer.dataset.shopUrl) + '">Design your wig</a></div>';
      foot.hidden = true; return cart;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          var v = it.properties[k];
          if (!v || k.charAt(0) === '_') return;
          props += '<div>' + esc(k) + ': <span>' + esc(v) + '</span></div>';
        });
      }
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div>' + esc(it.variant_title) + '</div>' : '';
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="88" height="110">' : '';
      return '<div class="line-item"><a class="line-item__img" href="' + esc(it.url) + '">' + img + '</a><div><a class="line-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="line-item__props">' + variant + props + '</div><div class="line-item__row"><div class="qty"><button type="button" aria-label="Decrease" data-qty="' + (i + 1) + '" data-val="' + (it.quantity - 1) + '">−</button><input type="number" value="' + it.quantity + '" aria-label="Quantity" readonly><button type="button" aria-label="Increase" data-qty="' + (i + 1) + '" data-val="' + (it.quantity + 1) + '">+</button></div>' +
        '<span>' + money(it.final_line_price) + '</span></div><button type="button" class="line-item__remove" data-qty="' + (i + 1) + '" data-val="0" style="margin-top:12px">Remove</button></div></div>';
    }).join('');
    $('.cart-subtotal', drawer).textContent = money(cart.total_price);
    return cart;
  }
  function refreshCart() { return fetch(W.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]'); if (!b) return;
      b.disabled = true;
      fetch(W.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.qty, quantity: Math.max(0, +b.dataset.val) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    });
  }
  W.openDrawer = openDrawer; W.refreshCart = refreshCart;

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('.gallery__slide', g), thumbs = $$('.gallery__thumbs button', g);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        thumbs.forEach(function (s, j) { s.classList.toggle('is-active', i === j); s.setAttribute('aria-current', i === j); });
      });
    });
  });

  /* ---------- Wig configurator ---------- */
  var form = $('[data-configurator]');
  if (form) {
    var dataEl = $('#ProductJSON');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = $('input[name="id"]', form);
    var priceEls = $$('[data-price]');
    var compareEls = $$('[data-compare]');
    var atcButtons = $$('[data-atc]');
    var errorEl = $('[data-config-error]', form);

    var selectedOptions = function () {
      return product.options.map(function (_, i) {
        var c = $('input[name="option' + (i + 1) + '"]:checked', form);
        var s = $('select[name="option' + (i + 1) + '"]', form);
        return c ? c.value : (s ? s.value : null);
      });
    };
    var findVariant = function (opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    };
    var update = function () {
      if (!product) return;
      var opts = selectedOptions();
      var v = findVariant(opts);
      // mark unavailable combos for the last option level
      product.options.forEach(function (_, idx) {
        $$('input[name="option' + (idx + 1) + '"]', form).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var match = findVariant(test);
          inp.disabled = !match;
        });
      });
      if (v) {
        if (String(idInput.value) !== String(v.id)) { idInput.value = v.id; idInput.dispatchEvent(new Event('change')); }
        priceEls.forEach(function (el) { el.textContent = money(v.price); });
        compareEls.forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
        atcButtons.forEach(function (b) {
          b.disabled = !v.available;
          var label = $('[data-atc-label]', b); if (label) label.textContent = v.available ? b.dataset.labelOn : b.dataset.labelOff;
        });
        if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
        var inst = $('[data-installments-variant]'); if (inst) inst.value = v.id;
      }
      // reflect choices in step headers & summary
      $$('[data-step-value]', form).forEach(function (el) {
        var name = el.dataset.stepValue;
        var checked = $('[name="' + name + '"]:checked', form) || $('select[name="' + name + '"]', form);
        el.textContent = checked ? checked.value : '';
      });
      var sum = $('[data-summary]');
      if (sum) {
        var rows = '';
        product.options.forEach(function (n, i) { rows += '<dt>' + esc(n) + '</dt><dd>' + esc(opts[i] || '—') + '</dd>'; });
        $$('[data-summary-field]', form).forEach(function (f) {
          var val = f.type === 'radio' ? (f.checked ? f.value : null) : f.value;
          if (val && f.type === 'radio' && !f.checked) return;
          if (!val) return;
          rows += '<dt>' + esc(f.dataset.summaryField) + '</dt><dd>' + esc(val) + '</dd>';
        });
        sum.innerHTML = rows;
      }
      // custom measurements toggle
      var cap = $('[name="properties[Cap Size]"]:checked', form);
      var measure = $('[data-measurements]', form);
      if (measure) {
        var isCustom = cap && /custom/i.test(cap.value);
        measure.hidden = !isCustom;
        $$('input', measure).forEach(function (i) { i.required = !!isCustom && i.dataset.req === 'true'; i.disabled = !isCustom; });
      }
    };
    form.addEventListener('change', update);
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.textContent = '';
      if (!form.reportValidity()) return;
      var btn = e.submitter || $('[data-atc]', form);
      var buyNow = btn && btn.hasAttribute('data-buy-now');
      btn && btn.classList.add('is-loading');
      var fd = new FormData(form);
      // drop empty properties so the cart & order stay clean
      var clean = new FormData();
      fd.forEach(function (val, key) { if (/^option\d/.test(key)) return; if (key.indexOf('properties[') === 0 && !String(val).trim()) return; clean.append(key, val); });
      fetch(W.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: clean })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (buyNow) { window.location = '/checkout'; return; }
          return refreshCart().then(openDrawer);
        })
        .catch(function (err) { if (errorEl) errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; })
        .then(function () { btn && btn.classList.remove('is-loading'); });
    });

    // sticky add-to-cart bar
    var sticky = $('.sticky-atc'), anchor = $('[data-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(anchor);
      $('[data-sticky-scroll]', sticky).addEventListener('click', function () { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  /* ---------- Lead popup ---------- */
  var popup = $('#LeadPopup');
  function openPopup() { if (!popup || popup.classList.contains('is-open')) return; popup.classList.add('is-open'); popup.removeAttribute('aria-hidden'); store.set('wlw_popup', Date.now()); }
  function closePopup() { if (!popup) return; popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); }
  if (popup) {
    $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', closePopup); });
    var last = +store.get('wlw_popup') || 0;
    var days = +(popup.dataset.days || 14);
    var shouldShow = popup.dataset.forceOpen === 'true' || Date.now() - last > days * 864e5;
    if (popup.dataset.forceOpen === 'true') openPopup();
    else if (shouldShow) {
      var delay = (+popup.dataset.delay || 12) * 1000;
      setTimeout(openPopup, delay);
      document.addEventListener('mouseout', function ex(e) { if (!e.relatedTarget && e.clientY < 10) { openPopup(); document.removeEventListener('mouseout', ex); } });
    }
  }
  $$('[data-popup-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openPopup(); }); });

  /* ---------- Cart page qty ---------- */
  $$('[data-cart-page] [data-line]').forEach(function (b) {
    b.addEventListener('click', function () {
      fetch(W.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.val }) })
        .then(function () { window.location.reload(); });
    });
  });
})();
